import { performTokenRefresh } from '@/lib/api-client/api-client.utils'
import { logger } from '@/lib/logger'
import { useAuthStore } from '@/stores/auth'

export const AUTH_REFRESH_LOCK = 'signater:auth-refresh'

let refreshPromise: Promise<string> | null = null

export function ensureFreshToken(
  rejectedAccessToken: string | null,
): Promise<string> {
  if (refreshPromise) {
    return refreshPromise
  }

  refreshPromise = runExclusively(() =>
    refreshUnlessRotated(rejectedAccessToken),
  ).finally(() => {
    refreshPromise = null
  })

  return refreshPromise
}

async function runExclusively(task: () => Promise<string>): Promise<string> {
  if ('locks' in navigator) {
    return await navigator.locks.request(AUTH_REFRESH_LOCK, task)
  }

  return task()
}

async function refreshUnlessRotated(
  rejectedAccessToken: string | null,
): Promise<string> {
  await useAuthStore.persist.rehydrate()

  const { accessToken, refreshToken } = useAuthStore.getState()
  if (accessToken && accessToken !== rejectedAccessToken) {
    return accessToken
  }

  if (!refreshToken) {
    logger.warning('No refresh token available', undefined, 'auth')
    throw new Error('No refresh token available')
  }

  try {
    const { auth } = await performTokenRefresh(refreshToken)
    useAuthStore.getState().setAuth(auth)
    logger.info('Token refresh successful', undefined, 'auth')
    return auth.accessToken
  } catch (error) {
    logger.error(
      'Token refresh failed',
      error instanceof Error ? error : undefined,
      undefined,
      'auth',
    )
    throw error
  }
}
